import { createActionGroup, emptyProps } from '@ngrx/store';

export const NgrxMetaActions = createActionGroup({
  source: 'Meta',
  events: {
    'Reset Store': emptyProps(),
  },
});
